export default __webpack_public_path__ + "static/16-b81842575fe8d7d48aaf514bcfb7613b.png";